// @greenlight-spec: 19-design-system.md
// @greenlight-spec: 20-agent-plugins.md#marketplace-repo-bootstrap
// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: decisions/0040-multiple-plugin-marketplace-repositories.md

import * as React from 'react';

import { MarketplaceEditor } from '@/components/greenlight/marketplace/MarketplaceEditor';
import type {
  BootstrapMarketplace,
  UnregisterMarketplace,
} from '@/components/greenlight/marketplace/useMarketplaceEditor';
import { SectionCard } from '@/components/greenlight/SectionCard';
import { StatusBadge } from '@/components/greenlight/StatusBadge';
import type { OrgSettings } from '@greenlight/shared';

export interface MarketplaceCardProps {
  marketplace: OrgSettings['marketplace'];
  /** Connected SCM org handle, shown as a fixed prefix on the repository name field. */
  orgHandle: string | null;
  onBootstrap: BootstrapMarketplace;
  onUnregister: UnregisterMarketplace;
  focusCreate?: boolean;
}

export function MarketplaceCard({
  marketplace,
  orgHandle,
  onBootstrap,
  onUnregister,
  focusCreate = false,
}: MarketplaceCardProps): React.JSX.Element {
  const repositories = marketplace?.repositories ?? [];
  const badge = (
    <StatusBadge variant={repositories.length > 0 ? 'active' : 'inactive'}>
      {repositories.length === 0
        ? 'None created'
        : `${repositories.length} ${repositories.length === 1 ? 'repo' : 'repos'}`}
    </StatusBadge>
  );

  return (
    <SectionCard headerBar title="Greenlight agent plugin repo" badge={badge}>
      <MarketplaceEditor
        repositories={repositories}
        githubAppReady={marketplace?.github_app_ready ?? false}
        orgHandle={orgHandle}
        recoveryContext="settings"
        onBootstrap={onBootstrap}
        onUnregister={onUnregister}
        focusCreate={focusCreate}
        className="p-5"
      />
    </SectionCard>
  );
}
